module.exports = __webpack_public_path__ + "static/media/Barmag 4b3.52735127.jpg";